"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var testCondition = function testCondition(_ref) {
  var fieldValue = _ref.fieldValue,
      operator = _ref.operator,
      value = _ref.value;

  switch (operator) {
    case '==':
      {
        if (undefined === fieldValue) {
          return false;
        }

        switch (typeof fieldValue) {
          case 'string':
            {
              return Boolean(0 === String(fieldValue).localeCompare(value));
            }

          case 'number':
          default:
            {
              return Boolean(fieldValue === value);
            }
        }
      }

    case '!=':
      {
        if (undefined === fieldValue) {
          return false;
        }

        switch (typeof fieldValue) {
          case 'string':
            {
              return Boolean(0 !== String(fieldValue).localeCompare(value));
            }

          case 'number':
          default:
            {
              return Boolean(fieldValue !== value);
            }
        }
      }

    case '>':
      {
        if (undefined === fieldValue) {
          return false;
        }

        if (!Number.isNaN(Number(value)) && Number.isNaN(Number(fieldValue))) {
          return false;
        }

        return Boolean(fieldValue > value);
      }

    case 'in':
      {
        var newArray = value && !Array.isArray(value) ? value.split(',') : value;
        return undefined !== fieldValue && Boolean(newArray.includes(fieldValue));
      }

    case 'is':
      {
        return fieldValue !== 'false' && Boolean(fieldValue);
      }

    case 'not':
      {
        return !fieldValue;
      }

    case 'not-in':
      {
        var _newArray = value && !Array.isArray(value) ? value.split(',') : value;

        return undefined !== fieldValue && !_newArray.includes(fieldValue);
      }
  }

  return false;
};

exports.default = testCondition;